import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
// import { styled } from '@mui/material/styles';
import MenuItem from "@mui/material/MenuItem";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  calculateAge,
  convertDateToIndianFormat,
  handleKeyDown,
} from "../../Helper";
import { validateEmail } from "../../Helper";
import { validateImage } from "../../Helper";
import { getRequestGlobal, GLOBAL_URL } from "../../../API/global";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import AttachFileIcon from "@mui/icons-material/AttachFile";

// const Root = styled('div')(({ theme }) => ({
//     width: '100%',
//     margin: '10px',
//     color: theme.palette.text.secondary,
//     '& > :not(style) ~ :not(style)': {
//         marginTop: theme.spacing(2),
//     },
// }));

const PersonalDetail = ({
  formData,
  setFormData,
  errors,
  personalDetailsErrors,
  setPersonalDetailErrors,
}) => {
  const [dob, setBirthDate] = useState(formData.dob || null); // Display format
  const [isoBirthDate, setIsoBirthDate] = useState(formData.dob || null); // ISO format

  const [age, setAge] = useState(calculateAge(formData.dob) || "");
  const [selectedPassportPhoto, setSelectedPassportPhoto] = useState(null);
  const [qualification, setQualification] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedValue = value;
    if (name == "highest_qualification_id") {
      loadQualification(value);
    }
    //let updatedValue = JSON.parse(JSON.stringify(value));

    // console.log({ updatedValue })
    let errorMessage = "";
    if (name === "bio") {
      const wordCount = value.trim().split(/\s+/).length;

      if (wordCount > 200) {
        errorMessage = "Applicant Brief Bio cannot exceed 200 words.";
      } else {
        errorMessage = ""; // Clear the error message if word count is within the limit
      }
    }
    if (name === "bio2") {
      const wordCount = value.trim().split(/\s+/).length;

      if (wordCount > 200) {
        errorMessage = "cannot exceed 200 words.";
      } else {
        errorMessage = ""; // Clear the error message if word count is within the limit
      }
    }

    if (name === "reason_to_join") {
      const wordCount = value.trim().split(/\s+/).length;

      if (wordCount > 200) {
        errorMessage = "Details cannot exceed 200 words.";
      } else {
        errorMessage = ""; // Clear the error message if word count is within the limit
      }
    }

    // if (name === 'contact_number') {

    //     //    const phoneNumber = value.replace(/\D/g, '').slice(0, 10);
    //     const phoneNumber = value;

    //     if (phoneNumber.length < 20) {
    //         errorMessage = `Contact number requires ${10 - phoneNumber.length} more digits.`;
    //     } else if (phoneNumber.length > 20) {
    //         errorMessage = `Contact number must be exactly 10 digits.`;
    //     }
    // }

    if (name === "alternate_number") {
      //            const phoneNumber = value.replace(/\D/g, '').slice(0, 10);

      setPersonalDetailErrors((prevErrors) => ({
        ...prevErrors,
        [name]: errorMessage,
      }));
    }
    if (name === "email") {
      errorMessage = validatePersonalEmail(value);
    }
    // console.log({ updatedValue });
    setFormData({
      ...formData,
      [name]: updatedValue,
    });

    setPersonalDetailErrors({
      ...errors,
      [name]: errorMessage,
    });
  };

  // const validatePersonalEmailOne = (email) => {
  //     const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  //     const isValid = emailRegex.test(email);
  //     return email && !isValid ? 'Invalid email format' : '';
  // };

  const validatePersonalEmail = (email) => {
    if (!validateEmail(email)) return "Invalid email format";
    return "";
  };

  const handleDateChange = (date) => {
    if (!date) return;

    const isoFormattedDate = date.format("YYYY-MM-DD"); // ISO format for API
    const selectedDate = convertDateToIndianFormat(isoFormattedDate); // Display format

    setBirthDate(selectedDate); // Display format for input box
    setIsoBirthDate(isoFormattedDate); // ISO format for API and internal state

    const calculatedAge = calculateAge(isoFormattedDate);
    setAge(calculatedAge.toString());

    let dobError = "";
    if (calculatedAge > 35 || calculatedAge < 18) {
      dobError = "Age must be between 18 and 35.";
    }

    setPersonalDetailErrors({
      ...errors,
      dob: dobError,
    });

    setFormData({
      ...formData,
      dob: isoFormattedDate, // Save the date in ISO format for API
      age: calculatedAge.toString(),
    });
  };

  const minDate = dayjs("1991-07-01");
  const maxDate = dayjs("2008-07-01");

  // const minDate = dayjs().subtract(35, "year");
  // const maxDate = dayjs().subtract(18, "year");

  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
  ];

  let dateerror = errors.dob
    ? {
        textField: {
          helperText: errors.dob || " ",
          error: !!errors.dob,
        },
      }
    : {};
  const handlephotoPass = (event) => {
    setSelectedPassportPhoto(event.target.files[0]);
    // console.log("first_gov_id_proof success")
    const passportPhotoURL = event.target.files[0];
    const validatepassportPhotoURL = validateImage(passportPhotoURL);

    if (!validatepassportPhotoURL["status"]) {
      setPersonalDetailErrors({
        is_passport_photo: validatepassportPhotoURL.message,
      });
    } else {
      // console.log(firstGovtIdProof);
      setFormData((prevState) => ({
        ...prevState,
        passport_photo: passportPhotoURL,
        is_passport_photo: 1,
      }));

      setPersonalDetailErrors({
        is_passport_photo: "",
      });
    }
  };
  const loadQualification = () => {
    getRequestGlobal("qualification")
      .then((data) => {
        // console.log("Qualification Data:", data.data); // Check what data is being returned
        setQualification(data.data); // Set the qualification state
      })
      .catch((error) => {
        console.error("Error loading qualification data:", error);
      });
  };

  useEffect(() => {
    getRequestGlobal("qualification")
      .then((data) => {
        setQualification(data.data);
        // console.log({ permanent_state: formData.permanent_state });
        if (formData.highest_qualification_id) {
          loadQualification(formData.highest_qualification_id);
        }
      })
      .catch((error) => {});
  }, []);

  return (
    <>
      <div className="cmot-phone">
        <h5>STEP 1</h5>
        <p>
          Personal Detail <span className="text-danger">*</span>
        </p>
      </div>
      <form>
        <Grid container spacing={2} className="cmot-grid mt-3">
          <Grid item xs={12} sm={6} lg={4} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="Full Name"
                type="text"
                fullWidth
                name="name"
                value={formData.name}
                onChange={handleChange}
                error={!!errors.name}
                helperText={errors.name}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} lg={4} className="p-1">
            <div className="cmot-date" style={{ width: "100%" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Date of Birth"
                  fullWidth
                  disableFuture
                  value={
                    isoBirthDate ? dayjs(isoBirthDate, "YYYY-MM-DD") : null
                  } // Ensure correct format here
                  onChange={handleDateChange}
                  minDate={minDate}
                  maxDate={maxDate}
                  format="DD/MM/YYYY" // Display format
                  placeholderText="DD/MM/YYYY"
                  slotProps={{
                    textField: {
                      InputProps: { readOnly: true },
                      readOnly: true,
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={!!errors.dob}
                      helperText={errors.dob}
                    />
                  )}
                />
              </LocalizationProvider>
            </div>
          </Grid>

          <Grid item xs={12} sm={6} lg={4} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="Age must be between 18 and 35."
                type="number"
                fullWidth
                name="age"
                value={age}
                InputProps={{
                  readOnly: true, // Ensure age field is read-only
                }}
                error={!!errors.age}
                helperText={errors.age}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} lg={4} className="p-1">
            <Box>
              <TextField
                id="gender-select"
                fullWidth
                label="Gender"
                select
                value={formData.gender || ""}
                onChange={handleChange}
                error={!!errors.gender}
                helperText={errors.gender}
                variant="outlined"
                name="gender"
              >
                {genderOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </Grid>

          {formData.gender == "Other" ? (
            <>
              <Grid item xs={12} sm={6} lg={4} className="p-1">
                <Box>
                  <TextField
                    id="other_gender"
                    fullWidth
                    label="Other Gender"
                    // select
                    value={formData.other_gender || ""}
                    onChange={handleChange}
                    error={!!errors.other_gender}
                    helperText={errors.other_gender}
                    variant="outlined"
                    name="other_gender"
                  ></TextField>
                </Box>
              </Grid>
            </>
          ) : (
            <></>
          )}
          <Grid item xs={6} sm={2} lg={2} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="(+ Country Code)"
                type="tel"
                fullWidth
                name="country_code"
                value={formData.country_code || ""}
                onChange={(e) => {
                  let value = e.target.value;

                  // Allow the input to start with a '+', followed by numbers only
                  if (value) {
                    value = "+" + value.slice(1).replace(/[^0-9]/g, ""); // Keep only numbers after '+'
                  } else {
                    value = value.replace(/[^0-9]/g, ""); // If no '+', keep only numbers
                  }

                  // Restrict the input length to 4 characters (e.g., +123 or 123)
                  if (value.length > 4) {
                    value = value.slice(0, 4);
                  }

                  // Update formData
                  handleChange({
                    target: {
                      name: "country_code",
                      value,
                    },
                  });
                }}
                inputProps={{ maxLength: 4 }} // Max length including possible '+'
                error={!!errors.country_code}
                helperText={errors.country_code}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} lg={6} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="Mobile Number"
                // type="tel"
                type="number"
                fullWidth
                name="contact_number"
                inputProps={{ maxLength: 15 }}
                value={formData.contact_number || ""}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                onInput={(e) => {
                  if (e.target.value.length > 15)
                    e.target.value = e.target.value.slice(0, 15);
                }}
                error={!!errors.contact_number}
                helperText={errors.contact_number}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} lg={4} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="Email"
                type="email"
                fullWidth
                name="email"
                value={formData.email || ""}
                onChange={handleChange}
                error={!!errors.email}
                helperText={errors.email}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} lg={4} className="p-1">
            <Box>
              <input
                type="file"
                accept=".jpg,.jpeg, .png"
                onChange={handlephotoPass}
                style={{ display: "none", width: "100%" }}
                id="PassportPhoto"
                name="passport_photo"
              />
              <label htmlFor="PassportPhoto" style={{ width: "100%" }}>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder="Passport Size Photo (Jpeg/Jpg/PNG only) "
                  value={
                    selectedPassportPhoto ? selectedPassportPhoto.name : ""
                  }
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            document.getElementById("PassportPhoto").click()
                          }
                          edge="end"
                        >
                          <AttachFileIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {errors.is_passport_photo && (
                  <p className="error-msg">{errors.is_passport_photo}</p>
                )}
                {formData?.documentData?.[5] ? (
                  <div>
                    <span className="Attach_Photo_ID">
                      <a
                        href={`${GLOBAL_URL}downloadfile/cmot/${formData.id}/${formData.documentData[5].file}`}
                      >
                        {formData.documentData[5].name}
                      </a>
                    </span>
                  </div>
                ) : null}
              </label>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} lg={4} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="Highest Qualification"
                select
                fullWidth
                name="highest_qualification_id"
                value={formData.highest_qualification_id || ""}
                onChange={handleChange}
                error={!!errors.highest_qualification_id}
                helperText={errors.highest_qualification_id}
              >
                {Object.entries(qualification).map(([key, value]) => (
                  <MenuItem key={key} value={key}>
                    {value}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} lg={4} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="Name of Degree"
                type="text"
                fullWidth
                name="degree"
                value={formData.degree || ""}
                onChange={handleChange}
                error={!!errors.degree}
                helperText={errors.degree}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} lg={4} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="Year of Passing"
                type="number"
                fullWidth
                name="year_of_degree"
                value={formData.year_of_degree || ""}
                onChange={handleChange}
                error={!!errors.year_of_degree}
                helperText={errors.year_of_degree}
              />
            </Box>
          </Grid>

          {/* <Grid item xs={12} sm={6} lg={4} className="p-1">
                        {passportPhotoURL && (
                            <div style={{ width: '20%' }}>
                                <img src={passportPhotoURL} alt="Passport Photo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            </div>
                        )}
                    </Grid> */}

          <Grid item xs={12} sm={6} lg={12} className="p-1">
            {/* <Box>
                            <textarea
                                className="form-control text-area-class"
                                placeholder="Applicant Brief Bio (Not exceed 200 words)"
                                id="Applicant_brief"
                                style={{ height: '100px', borderRadius: '5px' }}
                                name="bio"
                                value={formData.bio || ''}
                                onChange={handleChange}
                            />
                        </Box> */}
            <Box>
              <TextField
                id="bio"
                label="Applicant Brief Bio (Not exceed 200 words)"
                multiline
                fullWidth
                // maxRows={4}
                name="bio"
                value={formData.bio || ""}
                onChange={handleChange}
              />
            </Box>
            {errors.bio && <p className="error-msg">{errors.bio}</p>}
          </Grid>

          <Grid item xs={12} sm={6} lg={12} className="p-1">
            {/* <Box>
                            <textarea
                                className="form-control"
                                placeholder="Why Do You Want To Participate In The Program? (Not exceed 200 words)"
                                id="Participate_res"
                                style={{ height: '100px', borderRadius: '5px' }}
                                name="reason_to_join"
                                value={formData.reason_to_join || ''}
                                onChange={handleChange}
                            />

                        </Box> */}
            <Box>
              <TextField
                id="reason_to_join"
                label="Why Do You Want To Participate In The Program? (Not exceed 200 words)"
                multiline
                fullWidth
                // maxRows={4}
                name="reason_to_join"
                value={formData.reason_to_join || ""}
                onChange={handleChange}
              />
            </Box>

            {errors.reason_to_join && (
              <p className="error-msg">{errors.reason_to_join}</p>
            )}
          </Grid>
          <Grid item xs={12} sm={6} lg={12} className="p-1">
            <Box>
              <TextField
                id="bio2"
                label="Describe a time when you helped your team succeed while also building relationships with new people. (Not exceed 200 words)"
                multiline
                fullWidth
                // maxRows={4}
                name="bio2"
                value={formData.bio2 || ""}
                onChange={handleChange}
              />
            </Box>

            {errors.bio2 && <p className="error-msg">{errors.bio2}</p>}
          </Grid>

          <Grid item xs={12} sm={6} lg={12} className="p-1">
            <Box>
              <TextField
                id="scale"
                type="number"
                label="How do you rate yourself as a team player? (1 being the lowest, 10 being the highest)"
                fullWidth
                name="scale"
                value={formData.scale || ""}
                onChange={(e) => {
                  let value = parseInt(e.target.value, 10);

                  // Ensure the value is between 1 and 10
                  if (value < 1) {
                    value = 1;
                  } else if (value > 10) {
                    value = 10;
                  }

                  handleChange({
                    target: {
                      name: "scale",
                      value: value,
                    },
                  });
                }}
              />
            </Box>

            {errors.scale && <p className="error-msg">{errors.scale}</p>}
          </Grid>

          {/* <Root>
                        <Divider>
                            <Chip label="Optional" size="small" />
                        </Divider>
                    </Root> */}
          <Grid item xs={6} sm={2} lg={2} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="(+ Country Code)"
                type="tel"
                fullWidth
                name="alternate_country_code"
                value={formData.alternate_country_code || "+"}
                onChange={(e) => {
                  let value = e.target.value;

                  // Ensure the value starts with '+'
                  if (!value.startsWith("+")) {
                    value = "+" + value.replace(/[^0-9]/g, ""); // Keep only numbers
                  } else {
                    value = "+" + value.slice(1).replace(/[^0-9]/g, ""); // Keep only numbers after the '+'
                  }

                  // Limit the length after the '+'
                  if (value.length > 4) {
                    value = value.slice(0, 4);
                  }

                  // Update formData
                  handleChange({
                    target: {
                      name: "alternate_country_code",
                      value,
                    },
                  });
                }}
                inputProps={{ maxLength: 4 }} // Max length includes the '+'
                error={!!errors.alternate_country_code}
                helperText={errors.alternate_country_code}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} lg={4} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="Alternate Number"
                // type="tel"
                type="number"
                fullWidth
                name="alternate_number"
                inputProps={{ maxLength: 15 }}
                value={formData.alternate_number || ""}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                onInput={(e) => {
                  if (e.target.value.length > 15)
                    e.target.value = e.target.value.slice(0, 15);
                }}
                error={!!errors.alternate_number}
                helperText={errors.alternate_number}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} lg={4} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="Website Link"
                type="url"
                fullWidth
                name="website_link"
                value={formData.website_link || ""}
                onChange={handleChange}
                error={!!errors.website_link}
                helperText={errors.website_link}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} lg={4} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="Twitter (Account Link)"
                type="url"
                fullWidth
                name="twitter_account_link"
                value={formData.twitter_account_link || ""}
                onChange={handleChange}
                error={!!errors.twitter_account_link}
                helperText={errors.twitter_account_link}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} lg={4} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="Instagram (Account Link)"
                type="url"
                fullWidth
                name="instagram_account_link"
                value={formData.instagram_account_link || ""}
                onChange={handleChange}
                error={!!errors.instagram_account_link}
                helperText={errors.instagram_account_link}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} lg={4} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="Facebook (Account Link)"
                type="url"
                fullWidth
                name="facebook_account_link"
                value={formData.facebook_account_link || ""}
                onChange={handleChange}
                error={!!errors.facebook_account_link}
                helperText={errors.facebook_account_link}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} lg={4} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="LinkedIn (Account Link)"
                type="url"
                fullWidth
                name="linkedin_account_link"
                value={formData.linkedin_account_link || ""}
                onChange={handleChange}
                error={!!errors.linkedin_account_link}
                helperText={errors.linkedin_account_link}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} lg={12} className="p-1">
            {/* <Box>
                            <textarea
                                className="form-control"
                                placeholder="How Did You Find About CMOT?"
                                id="how_you_find"
                                style={{ height: '100px', borderRadius: '5px' }}
                                name="how_you_find"
                                value={formData.how_you_find || ''}
                                onChange={handleChange}
                            />
                        </Box> */}
            <Box>
              <TextField
                id="how_you_find"
                label="How Did You Find About CMOT ?"
                multiline
                fullWidth
                // maxRows={8}
                name="how_you_find"
                value={formData.how_you_find || ""}
                onChange={handleChange}
                error={!!errors.how_you_find}
                helperText={errors.how_you_find}
              />
            </Box>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default PersonalDetail;
